
import Vue from "vue";
import { BrowseStateBase } from "@/utils/browse/browse-state-base";

export default Vue.extend({
	props: {
		state: {
			required: true,
			type: Object as () => BrowseStateBase
		}
	},
	computed: {
		icon(): string{
			return this.state.quickSearch ? "times" : "";
		}
	},
	watch: {
		"search": {
			handler(){
				if (this.state.quickSearch == "") {
					console.trace("Search changed", this.state.quickSearch);
				}
			}
		},
		"state.querySettings.searchQuery"() {
			if(!this.state.querySettings.searchQuery){
				this.state.quickSearch = "";
			}
		}
	},
	methods: {
		onFocus(){
			this.$emit("focus");
			this.state.quickSearchFocused = true;
		},
		onBlur(){
			this.state.quickSearchFocused = false;
		},
		onClear(){
			this.state.quickSearch = "";
			this.$emit("enter",this.state.quickSearch);
		},
		onEnter(){
			let value = this.state.quickSearch;
			if (value.endsWith("%")) {
				value = value.slice(0, -1);
			}
			this.$emit("enter", value);
		}
	}
});
